import React from "react";
import { excluirGrupoContratoAluguel, getListaGrupoContratoAluguel, salvarGrupoContratoAluguel } from "../contratoAluguelActions";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { useEffect } from "react";
import Row from "../../common/layout/row";
import Grid from "../../common/layout/grid";
import Button from "../../common/button/button";
import { ModalAlert } from "../../common/dialog/modalAlert";
import { useState } from "react";
import LabelAndInput from "../../common/form/labelAndInput";
import THead from "../../common/table/tHead";
import Table from "../../common/table/table";
import Th from "../../common/table/th";
import TBody from "../../common/table/tBody";
import Td from "../../common/table/td";
import NewTr from "../../common/table/newTr";

const SALVAR = "salvar";
const EXCLUIR = "excluir";

function ModalGrupoContratoAluguelFormComponent(props) {
    if (!props.idCliente) return null;

    const [form, setForm] = useState(null);
    const [modo, setModo] = useState(null);

    useEffect(() => {
        props.getListaGrupoContratoAluguel({ idCliente: props.idCliente });
    }, [props.idCliente]);

    function resetForm() {
        setForm(null);
        setModo(null);
    }

    const cliente = props.listaCliente.find((cli) => cli.id == props.idCliente) || {};
    const nomeCliente = <span style={{ textDecoration: "underline" }}> {cliente.valor || "INDEFINIDO"}</span>;
    return (
        <ModalAlert titulo="Grupos de Análise de Contratos de Aluguéis" handleClose={props.handleClose}>
            <div style={{ textAlign: "center", color: "#d00404" }}>
                <h6>(Exclusivos para o cliente {nomeCliente})</h6>
            </div>
            <Row>
                {form ? (
                    <>
                        <LabelAndInput
                            name="nome"
                            label="Nome"
                            placeholder="Informe o nome"
                            readOnly={modo === EXCLUIR}
                            cols={"12 12 8 8"}
                            value={form.nome}
                            onChange={(e) => setForm({ ...form, nome: e.target.value })}
                        />
                        <Grid cols="12 12 2 2">
                            {modo === SALVAR ? (
                                <>
                                    <Button
                                        style={{ margin: "30px 0px 0px 0px", width: "100%" }}
                                        type={"success"}
                                        text="Salvar"
                                        icon={"fas fa-check"}
                                        disabled={false}
                                        event={() => {
                                            props.salvarGrupoContratoAluguel(form, resetForm);
                                        }}
                                    />
                                </>
                            ) : modo === EXCLUIR ? (
                                <Button
                                    style={{ margin: "30px 0px 0px 0px", width: "100%" }}
                                    text="Excluir"
                                    type={"danger"}
                                    icon={"fas fa-check"}
                                    disabled={false}
                                    event={() => {
                                        props.excluirGrupoContratoAluguel(form, resetForm);
                                    }}
                                />
                            ) : null}
                        </Grid>
                        <Grid cols="12 12 2 2">
                            <Button
                                style={{ margin: "30px 0px 0px 0px", width: "100%" }}
                                type={"warning"}
                                text="Voltar"
                                icon={"fas fa-arrow-left"}
                                disabled={false}
                                event={() => {
                                    setForm(null);
                                }}
                            />
                        </Grid>
                    </>
                ) : (
                    <Grid cols="12 12 4 4">
                        <Button
                            style={{ margin: 0 }}
                            text={"Incluir Novo Grupo de Análise"}
                            type={"success"}
                            icon={"fas fa-plus"}
                            disabled={false}
                            event={() => {
                                setForm({ id_cliente: props.idCliente });
                                setModo(SALVAR);
                            }}
                        />
                    </Grid>
                )}
                {form ? null : (
                    <Grid cols="12 12 12 12">
                        <Table>
                            <THead>
                                <NewTr backgroundColorTr={"#FFFFFF"} backgroundColorTd={"#F5F5F5"}>
                                    <Th>Nome</Th>
                                </NewTr>
                            </THead>
                            <TBody>
                                {props.listaGrupoContratoAluguel.map((gca) => {
                                    return (
                                        <NewTr
                                            key={gca.id}
                                            backgroundColorTr={"#FFFFFF"}
                                            backgroundColorTd={"#F5F5F5"}
                                            botoes={[
                                                {
                                                    type: "warning",
                                                    icon: "fas fa-pencil-alt",
                                                    event: () => {
                                                        setForm({ id: gca.id, id_cliente: gca.id_cliente, nome: gca.nome });
                                                        setModo(SALVAR);
                                                    },
                                                },
                                                {
                                                    type: "danger",
                                                    icon: "fas fa-trash-alt",
                                                    event: () => {
                                                        setForm({ id: gca.id, id_cliente: gca.id_cliente, nome: gca.nome });
                                                        setModo(EXCLUIR);
                                                    },
                                                },
                                            ]}
                                        >
                                            <Td>{gca.nome}</Td>
                                        </NewTr>
                                    );
                                })}
                            </TBody>
                        </Table>
                    </Grid>
                )}
            </Row>
        </ModalAlert>
    );
}

const mapStateToProps = (state) => ({
    usuarioLogado: state.auth.usuarioLogado,
    listaCliente: state.contratoAluguel.listaCliente,
    listaGrupoContratoAluguel: state.contratoAluguel.listaGrupoContratoAluguel,
});
const mapDispatchToProps = (dispatch) => bindActionCreators({ getListaGrupoContratoAluguel, salvarGrupoContratoAluguel, excluirGrupoContratoAluguel }, dispatch);
export const ModalGrupoContratoAluguelForm = connect(mapStateToProps, mapDispatchToProps)(ModalGrupoContratoAluguelFormComponent);
